import { Box, IconButton, Typography } from "@mui/material";
import { LeftPanelCloseIcon, LeftPanelOpenIcon } from "../../assets/icons";
import { Logo } from "../../assets";
import ThemeToggle from "./ThemeToggle";
import { UserMenu } from "./UserMenu";

interface AppHeaderProps {
  onMenu: () => void;
  drawerOpen: boolean;
  title: string;
}

export const AppHeader = ({ onMenu, drawerOpen, title }: AppHeaderProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        px: 3,
        py: 1,
        position: "relative",
        zIndex: 10,
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      <IconButton edge="start" onClick={onMenu} sx={{ mr: 2 }}>
        {drawerOpen ? <LeftPanelCloseIcon /> : <LeftPanelOpenIcon />}
      </IconButton>
      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="subtitle2" noWrap>
          {title}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" gap={2}>
        <UserMenu />
        <ThemeToggle />
        <Logo maxWidth="100px" maxHeight="32px" />
      </Box>
    </Box>
  );
};
